import Input, { IInput } from '@components/std-components/Input'
import IosCloseCircleOutline from '@meronex/icons/ios/IosCloseCircleOutline'
import '@styles/Search/style.css'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Tooltip from '@material-ui/core/Tooltip'
import Icon from '@components/std-components/Icons'
import { SearchBigIcon, SearchIconNew } from '@components/UI-Components/svg'

export interface ISearch extends IInput {
  showSearchInput: boolean
  onSearchToggle: any
  enhancedViewEnabled?: boolean
}

export const Search: React.FC<ISearch> = ({
  showSearchInput = true,
  onSearchToggle,
  placeholder,
  enhancedViewEnabled,
  ...inputProps
}) => {
  const { t } = useTranslation()
  return showSearchInput ? (
    <div className={'search'}>
      <Input
        variant='standard'
        className={'search-input'}
        placeholder={placeholder}
        {...(inputProps as any)}
        autoFocus
        value={inputProps.value}
      />
      <div className={'search-close'} onClick={onSearchToggle}>
        <IosCloseCircleOutline size={18} />
      </div>
    </div>
  ) : (
    <Tooltip title={t('common.label.search', 'Search')}>
      <div onClick={onSearchToggle}>
        <Icon
          imageSrc={enhancedViewEnabled ? SearchBigIcon : SearchIconNew}
          alt={'search'}
        />
      </div>
    </Tooltip>
  )
}
